module.exports = __webpack_public_path__ + "img/company1-1.714315d6.png";